import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorShape from '@/components/common/svg/shapes/ErrorShape.tsx';
import {
  verifiedPhotoRequiredStyle,
  verifiedPhotoRequiredTextStyle
} from '@/pages/Messenger/styles.ts';

const InsufficientDataBottomBar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={verifiedPhotoRequiredStyle}>
      <ErrorShape
        width={32}
        height={32}
        fillColor="#b4b6bc"
        style={{ marginRight: 5 }}
      />
      <span style={verifiedPhotoRequiredTextStyle}>
        {t('chats.verified_photos_required')}
      </span>
    </div>
  );
};

export default InsufficientDataBottomBar;